jQuery(document).ready(function($)
{
    // Fire the menu shrink function
    $(document).trigger('shrink-menu-init');
    $(document).trigger('shrink-menu');

});

